<template>
  <form class="register-form" @submit.prevent="registerUser">
    <div class="top-wrap">
      <router-link to="/">
        <img src="../../../assets/logo.svg" alt="">
      </router-link>
      <h1 class="title font-semi-bold">{{$t('registration.title')}}</h1>
    </div>
    <hr>
    <div class="fieldset">
      <div class="wrap">

        <label class="input-cont" :class="{'error': $v.name.$error}">
          <div class="icon">
            <icon-name></icon-name>
          </div>
          <input type="text"
                 v-model="name"
                 @blur="$v.name.$touch()"
                 @focus="$v.name.$reset()"
                 :placeholder="$t('forms.namePl') + ' *'">
          <errors v-show="$v.name.$error"></errors>
        </label>

        <label class="input-cont">
          <div class="icon">
            <icon-name></icon-name>
          </div>
          <input type="text"
                 v-model="surname"
                 :placeholder="$t('forms.surnamePl')">
        </label>

      </div>
      <div class="wrap">

        <label class="input-cont" :class="{'error': $v.mail.$error}">
          <div class="icon">
            <mail-light></mail-light>
          </div>
          <input type="mail"
                 v-model="mail"
                 @blur="$v.mail.$touch()"
                 @focus="$v.mail.$reset()"
                 :disabled="disableEmail"
                 :readonly="disableEmail"
                 :placeholder="$t('forms.email') + ' *'">
          <errors v-show="$v.mail.$error && !$v.mail.required"></errors>
          <errors type="mail" v-show="$v.mail.$error && !$v.mail.email"></errors>
        </label>

        <label class="input-cont">
          <!--<div class="icon">-->
            <!--<tel-light></tel-light>-->
          <!--</div>-->
          <div class="phone-cont">
            <phone-codes></phone-codes>
            <input type="tel"
                   v-model="tel"
                   v-mask="activeCode.code + ' ' + activeCode.mask"
                   @keypress="delString"
                   class="phone-input"
                   :placeholder="$t('forms.telPl')">
          </div>
        </label>

      </div>
      <div class="wrap">
        <label class="input-cont" :class="{'error': $v.pass.$error}">
          <div class="icon">
            <pass-icon></pass-icon>
          </div>
          <input :type="showPass ? 'text' : 'password'"
                 class="input-pass"
                 v-model="pass"
                 @blur="$v.pass.$touch()"
                 @focus="$v.pass.$reset()"
                 :placeholder="$t('forms.passwordLabel') + ' *'">
          <button type="button"
                  @mousedown="viewPass"
                  @mouseup="hidePass"
                  class="show-pass">
            <show-pass></show-pass>
          </button>
          <errors v-show="$v.pass.$error && !$v.pass.required"></errors>
          <errors type="passLength" :min-length="5" v-show="$v.pass.$error && !$v.pass.minLength"></errors>
        </label>

        <label class="input-cont" :class="{'error': $v.dublePass.$error}">
          <div class="icon">
            <pass-icon></pass-icon>
          </div>
          <input :type="showDuble ? 'text' : 'password'"
                 class="input-pass"
                 v-model="dublePass"
                 @blur="$v.dublePass.$touch()"
                 @focus="$v.dublePass.$reset()"
                 :placeholder="$t('forms.repeatPasswordPl') + ' *'">
          <button type="button"
                  @mousedown="viewDuble"
                  @mouseup="hideDuble"
                  class="show-pass">
            <show-pass></show-pass>
          </button>
          <errors type="passDouble" v-show="$v.dublePass.$error && !$v.dublePass.sameAs"></errors>
          <errors v-show="$v.dublePass.$dirty && !$v.dublePass.required"></errors>
        </label>
      </div>
    </div>
    <vue-recaptcha ref="captcha"
                   size="invisible"
                   :loadRecaptchaScript="true"
                   :sitekey="key">
    </vue-recaptcha>
    <div class="check-cont-wrap">
      <label class="check-cont_big check-cont">
        <input v-model="check"
               @click="callCaptcha"
               type="checkbox">
        <p class="check-label">
          {{$t('forms.notRobot')}}
        </p>
      </label>
      <img src="../../../assets/captcha.png" alt="">
    </div>
    <button type="submit"
            :disabled="disableBtn || loading"
            :class="{'loading': loading}"
            class="btn btn-green submit-btn">{{$t('btns.reg')}}</button>
    <div class="policy-check">
      <label class="check-cont_big check-cont">
        <input v-model="checkPrivacy" type="checkbox">
        <p class="check-label">
          {{$t('registration.acceptText')}} <router-link to="/" target="_blank">{{$t('registration.acceptLink')}}</router-link>
        </p>
      </label>
    </div>
  </form>
</template>

<script>
  import {mapMutations, mapActions} from 'vuex'
  import iconName from '../../Svg/loginUser'
  import mailLight from '../../Svg/mailLight'
  import TelLight from "../../Svg/telLight";
  import passIcon from '../../Svg/loginPass'
  import showPass from '../../Svg/showPass'
  import errors from '../../Forms/errors'
  import {required, email, minLength, sameAs} from 'vuelidate/lib/validators'
  import {validate} from "../../../mixins/utils/validate";
  import VueRecaptcha from 'vue-recaptcha'
  import {phoneCode} from "../../../mixins/utils/phoneCode";
  import {showOverlay} from "../../../mixins/utils/showOverlay";

  export default {
    name: 'registerForm',
    components: {
      TelLight,
      iconName,
      mailLight,
      passIcon,
      showPass,
      errors,
      VueRecaptcha
    },
    mixins: [validate, phoneCode, showOverlay],
    data() {
      return {
        name: '',
        surname: '',
        mail: '',
        disableEmail: false,
        tel: '',
        pass: '',
        showPass: false,
        dublePass: '',
        showDuble: false,
        check: false,
        checkPrivacy: false,
        loading: false,
        authKey: '',
        key: process.env.VUE_APP_CAPTCHA_SITE_KEY
      }
    },
    computed: {
      disableBtn() {
        if (this.$v.$anyError ||
          !this.check ||
          !this.checkPrivacy ||
          !this.name ||
          !this.mail ||
          !this.pass ||
          !this.dublePass
        ) {
          return true
        } else {
          return false
        }
      }
    },
    validations: {
      name: {
        required
      },
      mail: {
        required,
        email
      },
      pass: {
        required,
        minLength: minLength(5)
      },
      dublePass: {
        required,
        sameAs: sameAs('pass')
      }
    },
    methods: {
      ...mapMutations({
        showErrorLogin: 'popups/errorLogin/SHOW_ERROR_LOGIN'
      }),
      ...mapActions({
        getRegEmail: 'auth/getRegisterEmail'
      }),
      addEight() {
        if (!this.tel) {
          this.tel = '+7'
        }
      },
      checkLengthTel() {
        if (this.tel.trim().length < 5) {
          this.tel = ''
        }
      },
      viewPass() {
        this.showPass = true
      },
      hidePass() {
        this.showPass = false
      },
      viewDuble() {
        this.showDuble = true
      },
      hideDuble() {
        this.showDuble = false
      },
      callCaptcha() {
        this.$refs.captcha.execute();
      },
      registerUser() {
        this.loading = true;
        let data = {
          name: this.name,
          surname: this.surname,
          mail: this.mail,
          tel: this.tel,
          pass: this.pass,
          faceless: this.check,
          language: this.$i18n.locale.toUpperCase()
        };
        if (this.authKey) {
          data.auth_key = this.authKey
        };

        this.$store.dispatch('auth/register', data).then(() => {
          this.loading = false;
        }).catch((e) => {
          this.loading = false;
          this.showOverlay(true);
          this.showErrorLogin(true);
        })
      },
      async getEmail(key) {
        this.authKey = key;
        let email = await this.getRegEmail(key);
        this.mail = email.email;
        this.disableEmail = true;
      }
    },
    async mounted() {
      let key = this.$route.query;
      if (key && !!key.auth_key) {
        key = key.auth_key;
        this.getEmail(key);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .register-form {
    background: white;
    border-radius: 8px;
    box-shadow: 0px 4px 12px rgba(0, 82, 127, 0.2);
    width: 100%;
    max-width: 630px;
    margin: auto auto 30px;
    padding-bottom: 40px;
  }

  .top-wrap {
    padding: 30px 30px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  img {
    max-width: 230px;
  }

  .title {
    font-size: 18px;
    letter-spacing: 0.25px;
    color: $darkBlue;
  }

  hr {
    background: $lightGrey;
    border: none;
    height: 1px;
    margin: 30px 0;
  }

  .fieldset {
    padding: 0 30px 10px;
  }

  .wrap {
    display: flex;
    margin: 0 -5px 10px;

    .input-cont {
      margin: 0 5px;
      width: calc(50% - 5px);
    }
  }

  .phone-cont {
    .phone-input {
      padding-left: 60px;
    }

    .phone-code-wrapper {
      left: 5px;
      bottom: 7px;
    }
  }

  .check-cont-wrap {
    margin: 0 30px 40px;
    display: flex;
    align-items: center;
    padding: 20px;
    border-radius: 4px;
    border: 1px solid $lightGrey;
    justify-content: space-between;

    img {
      max-width: 98px;
    }
  }

  .submit-btn {
    max-width: 280px;
    margin: 0 auto 30px;
  }

  .policy-check {
    margin: 10px auto 0;
    display: flex;
    justify-content: center;

    a {
      color: $green;
      text-decoration: underline;
    }
  }
</style>
